<div class="shiksha-coming-soon">
    @if (hasShikshaDashboardAccess()) { @if (isDashboardLoading()) {
    <div
        class="shiksha-coming-soon__skeleton"
        [attr.aria-label]="dashboardStateText.loadingAriaLabel"
    >
        <div class="shiksha-coming-soon__skeleton-kpis">
            @for (item of [1, 2, 3, 4]; track item) {
            <app-skeleton-card
                class="shiksha-coming-soon__skeleton-card shiksha-coming-soon__skeleton-card--kpi"
                [showHeader]="false"
                [lines]="3"
                [lineWidths]="['full', 'l', 'm']"
            ></app-skeleton-card>
            }
        </div>
        <app-skeleton-card
            class="shiksha-coming-soon__skeleton-card shiksha-coming-soon__skeleton-card--lg"
            [showSubheader]="true"
            [lines]="6"
            [lineWidths]="['full', 'full', 'xl', 'l', 'm', 's']"
        ></app-skeleton-card>
        <div class="shiksha-coming-soon__skeleton-grid">
            <app-skeleton-card
                class="shiksha-coming-soon__skeleton-card"
                [showSubheader]="true"
                [lines]="5"
                [lineWidths]="['full', 'xl', 'l', 'm', 's']"
            ></app-skeleton-card>
            <app-skeleton-card
                class="shiksha-coming-soon__skeleton-card"
                [showSubheader]="true"
                [lines]="5"
                [lineWidths]="['full', 'xl', 'l', 'm', 's']"
            ></app-skeleton-card>
        </div>
        <div class="shiksha-coming-soon__skeleton-grid">
            <app-skeleton-card
                class="shiksha-coming-soon__skeleton-card"
                [showSubheader]="true"
                [lines]="5"
                [lineWidths]="['full', 'xl', 'l', 'm', 's']"
            ></app-skeleton-card>
            <app-skeleton-card
                class="shiksha-coming-soon__skeleton-card"
                [showSubheader]="true"
                [lines]="5"
                [lineWidths]="['full', 'xl', 'l', 'm', 's']"
            ></app-skeleton-card>
        </div>
    </div>
    } @else {
    <div class="shiksha-coming-soon__inner">
        <app-shiksha-kpi-strip [kpiItems]="kpiItems()"></app-shiksha-kpi-strip>

        <app-shiksha-sales-funnel [stages]="salesFunnelStages()"></app-shiksha-sales-funnel>
        <app-shiksha-deals-at-risk [items]="dealsAtRiskItems()"></app-shiksha-deals-at-risk>
        @if (isTeamScopeSelected()) {
        <app-shiksha-team-contribution [members]="teamMembers()"></app-shiksha-team-contribution>
        }
        <app-shiksha-revenue-by-client-type
            [clientTypeRevenues]="clientTypeRevenues()"
        ></app-shiksha-revenue-by-client-type>
        <app-shiksha-pipeline-risk
            [stages]="pipelineRiskSummary().stages"
        ></app-shiksha-pipeline-risk>
    </div>
    } } @else {
    <div class="shiksha-coming-soon__permission-empty" role="status" aria-live="polite">
        <p class="shiksha-coming-soon__permission-empty-title">
            {{ dashboardStateText.noAccessTitle }}
        </p>
        <p class="shiksha-coming-soon__permission-empty-text">
            {{ dashboardStateText.noAccessMessage }}
        </p>
    </div>
    }
</div>
